import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Palmtree } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function VacationBannerSettings({ refreshKey }) {
  const [cfg, setCfg] = useState({ enabled: true, custom_message: "" });
  const [preview, setPreview] = useState(null);
  const [saving, setSaving] = useState(false);

  const loadPreview = () =>
    axios.get(`${API}/api/vacation-banner`).then((r) => setPreview(r.data)).catch(() => setPreview(null));

  useEffect(() => {
    axios.get(`${API}/api/content/vacation_banner`).then((r) => setCfg({ enabled: true, custom_message: "", ...r.data })).catch(() => {});
  }, []);
  useEffect(() => { loadPreview(); }, [refreshKey]);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/api/admin/content/vacation_banner`, cfg);
      toast.success("Bandeau vacances enregistré");
      loadPreview();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur à l'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="vacation-banner-settings" className="bg-[#1C1C1E] border border-white/[0.06] rounded-md p-3 space-y-3">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <p className="text-white text-sm font-semibold flex items-center gap-2">
          <Palmtree size={15} className="text-amber-400" /> Bandeau vacances sur le site
        </p>
        <label className="flex items-center gap-2 text-white/70 text-xs cursor-pointer">
          <input
            type="checkbox"
            checked={cfg.enabled !== false}
            onChange={(e) => setCfg({ ...cfg, enabled: e.target.checked })}
            data-testid="vacation-banner-enabled"
            className="accent-[#FF3B30]"
          />
          Afficher automatiquement pendant une pause
        </label>
      </div>
      <div>
        <label className="block text-white/50 text-xs uppercase tracking-wider mb-1.5">
          Message personnalisé <span className="normal-case text-white/30">(vide = message automatique · {"{date}"} = date de reprise)</span>
        </label>
        <input
          value={cfg.custom_message || ""}
          onChange={(e) => setCfg({ ...cfg, custom_message: e.target.value })}
          placeholder="ex : L'atelier est en congés, réouverture le {date} !"
          data-testid="vacation-banner-custom-message"
          className="w-full bg-[#121212] border border-white/[0.06] rounded-md px-3 py-2 text-white text-sm focus:outline-none focus:border-white/20"
        />
      </div>
      <div>
        <p className="text-white/40 text-[11px] uppercase tracking-wider mb-1.5">Aperçu (enregistré)</p>
        {preview?.visible ? (
          <div data-testid="vacation-banner-preview" className="bg-amber-400 text-black text-xs font-bold rounded px-3 py-1.5">
            {preview.message}
          </div>
        ) : (
          <p data-testid="vacation-banner-preview-empty" className="text-white/40 text-xs italic">
            Aucun bandeau affiché actuellement (aucun service en pause ou bandeau désactivé).
          </p>
        )}
      </div>
      <button
        type="button"
        onClick={save}
        disabled={saving}
        data-testid="vacation-banner-save"
        className="bg-[#FF3B30] hover:bg-[#D63025] disabled:opacity-50 text-white text-xs font-semibold px-3 py-2 rounded transition-colors"
      >
        {saving ? "Enregistrement…" : "Enregistrer le bandeau"}
      </button>
    </div>
  );
}
